// Classifies an error caught from a wallet flow (transaction send,
// network switch, swap execution): false = the user deliberately
// declined in their wallet — an expected outcome, stay silent; true =
// anything else — a real failure the caller surfaces (notification /
// Sentry). Unrecognized shapes land on true, so the failure mode is a noisy
// report, never a swallowed real error. Rejection shapes recognized as
// false are accumulated per wallet — see the inline notes. `code` matches
// only as a number and `message` only as a string — no coercion, so
// `{code: '4001'}` is unexpected. ⚠️ Nullish input throws — pass the caught
// value itself, which in these flows is never null/undefined.
export function getIsSendTransactionErrorUnexpected(e: unknown): boolean {
  const err = e as { code?: unknown; message?: unknown; stack?: unknown };
  const message = typeof err.message === 'string' ? err.message : undefined;
  return !(
    err.code === 4001 || // EIP-1193 user rejection (MetaMask)
    // -32002 = request already pending — the wallet is still showing an
    // earlier popup, not a failure. -32603 is deliberately not treated as
    // a user rejection — it's MetaMask's generic internal-error code, not
    // a cancel.
    err.code === -32002 ||
    e === 'transaction was cancelled by user' || // Status
    (message !== undefined &&
      [
        'User denied',
        'User canceled', // Trust WalletConnect
        'cancelled', // Trust
        'User rejected',
        'Rejected by user', // Gnosis
        'Actions cancelled', // imToken
        'User closed modal', // WalletConnect
      ].some((m) => message.toLowerCase().includes(m.toLowerCase()))) ||
    (typeof err.stack === 'string' &&
      err.stack.includes('User denied transaction')) // MetaMask rejections that surface only in the stack
  );
}
